import React from 'react';
import { Input, Select, Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Controller, useForm } from 'react-hook-form';
import AlumlyButton from '../../../components/AlumlyButton';

export type FilterNewsT = { searchQuery?: string; status?: string };

interface Props {
  selectedFilter: FilterNewsT | undefined;
  setSelectedFilter: React.Dispatch<React.SetStateAction<FilterNewsT | undefined>>;
}

const FormFilterNewsList: React.FC<Props> = ({ selectedFilter, setSelectedFilter }) => {
  const { control, reset } = useForm({ defaultValues: { searchQuery: '', status: '' } });

  return (
    <div style={{
      padding: '16px 24px',
      marginTop: 24,
      background: 'white',
      border: '1px solid #E4E4E7',
      borderRadius: 12,
    }}
    >
      <Row gutter={16} align="middle">
        <Col xs={24} md={14}>
          <Controller
            name="searchQuery"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                allowClear
                size="large"
                prefix={<SearchOutlined style={{ color: '#A1A1AA' }} />}
                placeholder="Search by title"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  setSelectedFilter({ ...selectedFilter, searchQuery: e.target.value });
                }}
              />
            )}
          />
        </Col>
        <Col xs={24} md={6}>
          <Controller
            name="status"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Status"
                value={value || undefined}
                onChange={(val) => {
                  onChange(val ?? '');
                  setSelectedFilter({ ...selectedFilter, status: val || undefined });
                }}
                options={[
                  { value: '', label: 'All' },
                  { value: 'true', label: 'Published' },
                  { value: 'false', label: 'Draft' },
                ]}
              />
            )}
          />
        </Col>
        <Col xs={24} md={4}>
          <AlumlyButton
            label="rxvWhite"
            fullWidth
            onClick={() => { reset(); setSelectedFilter({}); }}
          >
            Reset filters
          </AlumlyButton>
        </Col>
      </Row>
    </div>
  );
};

export default FormFilterNewsList;
